'use client'

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function RootRedirect() {
  const navigate = useNavigate()
  const { firebaseUser, loadingAuth, profileLoading } = useAuth()

  useEffect(() => {
    if (loadingAuth || profileLoading) return
    navigate(firebaseUser ? '/dashboard' : '/login', { replace: true })
  }, [firebaseUser, loadingAuth, profileLoading, navigate])

  return null
}
